// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "svg.icon[data-v-5df3cea8]{color:#066e60}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
